import { Response } from '@/core'
import {
  HotelListParams,
  HotelListResponse,
  PackageBaseParams,
  SaveHotelSearchParams,
  GetHotelRoomsParams,
  HotelRoomsResponse,
  AddHotelParams,
  PackageApiBuilder,
} from './package.api.types'

export const hotelsEndpoints = (builder: PackageApiBuilder) => ({
  hotelList: builder.mutation<Response<HotelListResponse>, HotelListParams>({
    query: ({ params, data }) => ({
      url: '/package/hotel/list',
      method: 'post',
      params,
      data,
    }),
  }),
  removeHotel: builder.mutation<Response<void>, PackageBaseParams>({
    query: ({ sessionId }) => ({
      url: `/package/hotel/remove-hotel`,
      method: 'put',
      params: { sessionId },
    }),
  }),
  saveHotelSearchParams: builder.mutation<Response<void>, SaveHotelSearchParams>({
    query: ({ params, data }: SaveHotelSearchParams) => ({
      url: `/package/hotel/params`,
      method: 'put',
      params,
      data,
    }),
  }),
  getHotelRooms: builder.mutation<Response<HotelRoomsResponse>, GetHotelRoomsParams>({
    query: ({ params, data }: GetHotelRoomsParams) => ({
      url: `/package/hotel/rooms-and-rates-details`,
      method: 'post',
      params,
      data,
    }),
  }),
  addHotel: builder.mutation<Response<void>, AddHotelParams>({
    query: ({ params, data }: AddHotelParams) => ({
      url: `/package/hotel/add-hotel`,
      method: 'post',
      params,
      data,
    }),
  }),
})
